import React, { createRef, useEffect } from "react";
import { usePositionedScreenContext } from "../../PositionedScreen";

const SectionNode = ({ node, className, style, renderLayout, resizeHandle, handlers }) => {
  const { elementRefs } = usePositionedScreenContext();

  if (elementRefs?.current && node?.id) {
    if (!elementRefs.current[node.id]) {
      elementRefs.current[node.id] = createRef();
    }
  }
  useEffect(() => {
    const el = elementRefs.current[node.id]?.current;
    if (el) {
      el.setAttribute("data-type", node.type);
    }
  }, [elementRefs, node.id, node.type]);

  return (
    <div
      key={node.id}
      ref={elementRefs.current[node.id]}
      title={node.type}
      className={`screen-section ${className}`}
      style={style}
      {...handlers}
    >
      {resizeHandle(node)}
      {renderLayout(node.children)}
    </div>
  );
};

export default SectionNode;
